export const TypeAccessOptions = [
  'Administrador',
  'Consultor',
  'Gerente',
  'Padrão',
  'Franquia',
];